export default __webpack_public_path__ + "static/media/BW.fe7ecfa7.svg";